import React, {Component} from 'react';
import {Calendar,Toast} from 'antd-mobile';
import {changeShiftList} from "../../../service/shiftService";
import "./style.less";
import moment from 'moment';
import {connect} from "react-redux";
const now = new Date();
const noShift = require('../../../common/image/noShift.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class SelectShift extends Component {
    originbodyScrollY = document.getElementsByTagName('body')[0].style.overflowY;
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            isFlag:false,
            show:false,
            config: {},
            startTime:now,
            changeShiftData:[],
        };
    }
    componentDidMount(){
       this.changeShiftList(now);
    }
    //改签列表请求
    changeShiftList = (startTime) => {
        let params = {
            "source":6,
            "token": this.props.userInfo.token,
            "data": {
                "startPosition": this.props.location.state.startPosition,
                "endPosition": this.props.location.state.endPosition,
                "startCity": this.props.location.state.startCity,
                "endCity": this.props.location.state.endCity,
                "startDate": moment(startTime).format('YYYY-MM-DD'),
                "dispatcherId":this.props.userInfo.userId,
                "lineIds":this.props.location.state.lineIds,
            }
          }
          Toast.loading("正在加载",0);
          changeShiftList(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    Toast.hide();
                    this.setState({
                        changeShiftData:res.data.data.shiftCarResults ? res.data.data.shiftCarResults : [],
                    })
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {

                    this.setState({ changeShiftData:[]})
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
              console.log(error);
          });
    }
    colorChange(){
        let isFlag = this.state.isFlag;
        isFlag = !isFlag;
        this.setState({isFlag})
    };
    renderBtn(config = {}) {
        return(
            <div className="timeDiv">
                <span className="before" onClick={()=>this.selDay('before')}>前一天</span>
                <div className="time"
                     onClick={() => {
                         document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
                         this.setState({
                             show: true,
                             config,
                         });
                     }}
                >
                    <i className="icon iconfont iconriqixuanze"/>
                    <span>{moment(this.state.startTime).format('MM月DD日')}</span>
                    <i className="icon iconfont iconzhandianxialaxuanze"/>
                </div>
                <span className="after" onClick={()=>this.selDay('after')}>后一天</span>
            </div>
        )
    }
    selDay(type){
        let nowDate = this.state.startTime;
        if(type === 'before' && nowDate <= now){
            Toast.info("不能小于今天",2);
            return
        }
        if(type === 'after' && moment(nowDate).format('YY年MM月DD日') >= moment(new Date(+now + 5184000000)).format('YY年MM月DD日')){
            Toast.info("不能大于预售期",2);
            return
        }
        if(type === 'before' && nowDate > now){
            this.setState({
                startTime:moment(nowDate).subtract(1,"day")
            });
            this.changeShiftList(moment(nowDate).subtract(1,"day").format('YYYY-MM-DD'))
        }else
        if(type === 'after' && moment(nowDate).add(1,"day").format('YY年MM月DD日') <= moment(new Date(+now + 5184000000)).format('YY年MM月DD日')){
            this.setState({
                startTime:moment(nowDate).add(1,"day")
            });
            this.changeShiftList(moment(nowDate).add(1,"day").format('YYYY-MM-DD'))
        }
    }
    onConfirm = (startTime) => {
        document.getElementsByTagName('body')[0].style.overflowY = this.originbodyScrollY;
        this.setState({
            show: false,
            startTime,
        });
        this.changeShiftList(startTime);
        
    };

    onCancel = () => {
        document.getElementsByTagName('body')[0].style.overflowY = this.originbodyScrollY;
        this.setState({
            show: false,
        });
    };
    goSelSeat(shiftId,startStationId,endStationId,status){
        console.log(this.props.history.location.state)
        if(status === 0 ){
            let props = this.props.history.location.state
            let data={
                "shiftId":shiftId,
                "startPosition": props.startPosition,
                "endPosition": props.endPosition,
                "startStationId":startStationId,
                "endStationId":endStationId,
                "orderId":props.id,
                "startAddress":props.startAddress,
                "endAddress":props.endAddress,
                "type":props.type,
                "classId":props.classId,
                "totalPrice":props.totalPrice
    
            }
            this.props.history.push('/orderChange',data);
        }
       
    }
    render(){
        const state = this.props.history.location.state
        return(
            <div className="selectShift">
                <div className="topBar">
                    <div className="goBack">
                        <i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />
                        改签
                    </div>
                    <div className="cityName">
                        {state.startCity} —— {state.endCity}
                    </div>

                    {this.renderBtn({ type: 'one' })}

                    <div className="hint"><i className="icon iconfont icongonggao"/>根据国家规定，上车前必须携带身份证进行身份核实上车前必须携带身份证进行身份核实！</div>
                </div>
                {/*<button onClick={()=>this.colorChange()}>改变字体颜色</button>*/}

                <div className="warpBox">
                    <div className="content">

                        {
                            (<div className="mapList">
                                    {
                                        this.state.changeShiftData.length > 0 ?
                                            this.state.changeShiftData.map((res,index)=>(
                                                <div className="item"
                                                    key={index}
                                                    style={ res.status == 0 ? null : {
                                                        backgroundColor: '#f9f9f9',
                                                        opacity: 0.5
                                                    }}
                                                    onClick={()=>this.goSelSeat(res.id,res.startStationId,res.endStationId,res.status)}
                                                >
                                                    <div className="left">
                                                        <div className="startTime">{res.startTime}<span>发车</span></div>
                                                        <div className="pickUpTime">{res.pickUpTime} 开始接人</div>
                                                    </div>
                                                    <div className="right">
                                                        <div className="carType">
                                                            <p>{res.carModel}</p>
                                                            <p className="type">车型</p>
                                                        </div>
                                                        <div className="picDiv">
                                                            {
                                                                res.status == 1 ? <span>已发车<p className="type">￥{res.price}&nbsp;&nbsp;起</p></span>: (res.remainingSeat == 0 ? 
                                                                <span style={{color:'#F79E24'}}>已满员<p className="type">￥{res.price}&nbsp;&nbsp;起</p></span> 
                                                                :<span>剩余：<p className="num">{res.remainingSeat}</p><p className="type">￥{res.price}&nbsp;&nbsp;起</p></span>)
                                                            }
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            )): (
                                                <div className="noData">
                                                    <img src={noShift}/>
                                                    <p>暂无行程</p>
                                                </div>
                                            )
                                    }
                                </div>
                            )
                        }
                    </div>
                </div>

                <Calendar
                    {...this.state.config}
                    visible={this.state.show}
                    onCancel={this.onCancel}
                    onConfirm={this.onConfirm}
                    defaultDate={now}
                    minDate={now}
                    maxDate={new Date(+now + 5184000000)}
                    title={'选择日期'}
                    defaultTimeValue={now}
                />
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Member/SelectShift/index.js